<div class="menu-header">
    <button mat-icon-button class="color-mode-toggle"
            (click)="emit_colorMode_toggle()"
            [matTooltip]="_theme.ColorMode$$() === 'dark' ? 'Naar lichte modus' : 'Naar donkere modus'">
        <mat-icon>{{ _theme.ColorMode$$() === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
    <button mat-icon-button class="language-toggle"
            (click)="emit_language_toggle()"
            [matTooltip]="_languageTooltip()">
        <img class="flag-icon" [src]="_flagSrc[_language.Current$$()]" [alt]="_langLabel[_language.Current$$()]" />
    </button>
    <div class="side-container right invisible">
        <app-button-navigation />
    </div>
</div>
<div class="list-group">
    <mat-nav-list>
        <!-- @for (item of menuItems; track item) {
        <span>
            <app-menu-item [item]="item" />
        </span>
        } -->
    </mat-nav-list>
    <app-navigation-history />
    </div>
    <div class="menu-footer">
    <div class="footerblock">
        <div class="side-container right">
        <app-button-navigation 
            (btnClick)="toggleSidenav()"
            [tooltip]="'cancel'"
            [tooltipPosition]="'above'"
            ><app-icon name="xmark" />
        </app-button-navigation>
        </div>
    </div>
</div>
